module.exports = __webpack_public_path__ + "static/media/hire.4b63d29d.svg";